/**
 * Apps where Amplitude Guides and Surveys is enabled - the replacement for Pendo.
 *
 * Adding an app here enables Amplitude Guides and Surveys for it; the guides and surveys themselves are configured in the Amplitude dashboard.
 */
export const GUIDES_AND_SURVEYS_ENABLED_APPS = new Set<string>(['admin-dashboard', 'consumer-home', 'search-v2']);
